export const TEXTS = {
  betaNotice:
    "Note: Private Beta Access — This website is currently in a pre-release development phase and is intended strictly for private circulation. Access is limited to a select audience for testing and evaluation purposes. Confidentiality: Please refrain from forwarding this link or sharing any internal content. All intellectual property and sole proprietorship rights are held by DoCity Civil Engineers Private Limited. We value your partnership and look forward to your feedback as we prepare for our public launch.",
  footer: {
    contactUs: "Contact us",
    quickLinks: "Quick Links",
    aboutUs: "About Us",
    production: "Production",
    faq: "FAQ",
    properties: "Properties",
    contactUsLink: "Contact Us",
    termsAndConditions: "Terms & Conditions",
    rightsReserved: "All Rights Reserved.",
    engineerTask: "Engineer Task Center"
  }
};

